import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/WishlistApi" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */

/**
 * Updates the status ID of the wish list
 * @param {any} wishListHeaderId
 * @param {any} status
 */
export const updateWishListStatus = ( wishListHeaderId, status ) => {
  return instance.post( "UpdateWishListStatus",
    null,
    {
      wishListHeaderId: wishListHeaderId,
      status: status
    } );
};

/**
 * List wishlists against the logged in user.
 * @param {boolean} includeCompleted Whether to include completed wishlists or not.
 * @param {boolean} showAll Whether to show all wishlists for the current user org ID
 */
export const listWishlists = ( includeCompleted, showAll ) => {
  return instance.get( `ListWishlists?includeCompleted=${includeCompleted}&showAll=${showAll}` );
};

/**
 * Gets a wishlist.
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 */
export const getWishlist = ( orderHeaderId ) => {
  return instance.get( `GetWishlist?orderHeaderId=${orderHeaderId}` );
};

/**
 * Creates a new wishlist.
 * @param {string} title The wishlist title.
 */
export const createWishlist = ( title ) => {
  return instance.post( "CreateWishlist", null, {
    title
  } );
};

/**
 * Deletes a wishlist
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 */
export const deleteWishlist = ( orderHeaderId ) => {
  return instance.post( "DeleteWishlist", null, {
    orderHeaderId
  } );
};

/**
 * Renames a wishlist
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 * @param {String} newTitle The new wishlist title.
 */
export const renameWishlist = ( orderHeaderId, newTitle ) => {
  return instance.post( "RenameWishlist", null, {
    orderHeaderId,
    newTitle
  } );
};

/**
 * Saves wishlist data
 * @param {Object} wishlist The wishlist data to save.
 */
export const saveWishlist = ( wishlist ) => {
  return instance.post( "SaveWishlist", wishlist );
};

/**
 * Emails a wishlist
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 * @param {string} toAddress The recipient address.
 */
export const emailWishlist = ( orderHeaderId, toAddress ) => {
  return instance.post( "EmailWishlist", {
    orderHeaderId,
    toAddress
  } );
};

/**
 * Adds a product to a wishlist.
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 * @param {Number} productId The product ID to add.
 * @param {Number} pricingScheduleId The pricing schedule ID to use.
 * @param {Number} productFormatId The product format ID to use.
 * @param {Number} productLicenceTypeId The product licence type ID to use.
 * @param {Number} quantity The product quantity to use.
 */
export const addToWishlist = (
  orderHeaderId,
  productId,
  pricingScheduleId,
  productFormatId,
  productLicenceTypeId,
  quantity
) => {
  return instance.post( "AddToWishlist", null, {
    orderHeaderId,
    productId,
    pricingScheduleId,
    productFormatId,
    productLicenceTypeId,
    quantity
  } );
};

/**
 * Add multiple pack items to a wishlist.
 * @param {GUID} orderHeaderId The order header ID of the wishlsit.
 * @param {Array} bulkProducts The list of products to add to the wishlist.
 */
export const bulkAddToWishlist = ( orderHeaderId, bulkProducts ) => {
  return instance.post( "BulkAddToWishlist", bulkProducts, {
    orderHeaderId
  } );
};

/**
 * Removes a product from a wishlist.
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 * @param {GUID} orderLineId The order line ID to remove from the wishlist.
 */
export const removeFromWishlist = ( orderHeaderId, orderLineId ) => {
  return instance.post( "RemoveFromWishlist", null, {
    orderHeaderId,
    orderLineId
  } );
};

/**
 * Add wishlist products to the basket.
 * @param {GUID} orderHeaderId The order header ID of the wishlist.
 * @param {Array} productIds The list of product IDs to add to the basket.
 */
export const addToBasket = ( orderHeaderId, productIds ) => {
  return instance.post( "AddToBasket", productIds, {
    orderHeaderId
  } );
};

/**
 * Check if the current user is an org admin.
 */
export const isUserOrgAdmin = () => {
  return instance.post( "IsUserOrgAdmin" );
};
